export function setUser(name, profile, id, profile_pic, cpfcnpj, type) {
  return {
    type: "@user/LOGIN",
    payload: { name, profile, id, profile_pic, cpfcnpj, type },
  };
}
